import Axios from "axios";
import { nation } from "../atoms/nation";
import { Athlete } from "../atoms/athlete";
import { User } from "../atoms/user";

export class Api {
    baseUrl = "https://xhk43c3jb8.execute-api.eu-north-1.amazonaws.com/prod/";
    async login(user: string) {
         let res = await Axios.post(this.baseUrl + "login",{login: user});
        return res.data as {user:string, role: string};
    }

     async getEvents() {
        let res = await Axios.get(this.baseUrl + "startlists");
        return res.data;
    }
    async getRaces(eventId: string) {
        let res = await Axios.get(this.baseUrl + "startlists/"+eventId);
        return res.data;
    }

    async getStartlist(eventId: string, raceId: string) {
        let res = await Axios.get(this.baseUrl + "startlists/"+eventId+"/"+raceId);
        return res.data;
    }


    async getNations() {
        let res = await Axios.get(this.baseUrl + "nations");
        return res.data as nation[];
    }
    async getAthletes() {
        let res = await Axios.get(this.baseUrl + "athletes");
        return res.data as Athlete[];
    }
    async updateAthlete(athlete: Athlete) {
        let res = await Axios.put(this.baseUrl + "athletes/"+athlete.id, athlete);
        return res.data as boolean;
    }
    async listUsers() {
        let res = await Axios.get(this.baseUrl + "login/listusers");
        return res.data as User[];
    }
    async addUser(user: string, admin: boolean) {
        let res = await Axios.put(this.baseUrl + "login", {login: user, role: admin ? 'admin' : 'user'});
        return res.data;
    }
    async removeUser(user: string) {
        let res = await Axios.delete(this.baseUrl + "login/"+user);
        return res.data;
    }
}